<script setup>
const props = defineProps({
  name: {
    type: String,
    default: ''
  },
  pref: {
    type: String,
    default: ''
  },
  center: {
    type: Object,
    default: () => ({})
  }
})
const route = useRoute()
const path = route.path
const logList = ref([])
// ローカルストレーに保存する関数
const saveArrayToLocalStorage = (key, array) => {
  localStorage.setItem(key, JSON.stringify(array))
}
// ローカルストレージから読み出す関数
const getArrayFromLocalStorage = (key) => {
  const data = localStorage.getItem(key)
  return data ? JSON.parse(data) : []
}
onBeforeMount(() => {
  if (import.meta.client) {
    logList.value = getArrayFromLocalStorage('golf_history')
  }
})

onMounted(() => {
  if (import.meta.client && props.name && props.pref) {
    let newLogList = [...logList.value]
    // 現在のパスと一致するものを削除
    newLogList = newLogList.filter((item) => item.href !== path)
    if (newLogList.length >= 5) {
      newLogList = newLogList.slice(0, 4)
    }
    newLogList.unshift({ name: props.name, pref: props.pref, href: path, center: props.center })
    saveArrayToLocalStorage('golf_history', newLogList)
    logList.value = newLogList
  }
})
</script>

<template>
  <section class="golfLog">
    <CommonSectionTitle
      title="閲覧履歴"
    />
    <ClientOnly>
      <div
        v-if="logList.length!==0"
        class="block"
      >
        <template
          v-for="item in logList"
          :key="item.name"
        >
          <GolfCalendar :content="item" />
        </template>
      </div>
      <div
        v-else
        class="block"
      >
        <p>閲覧履歴はありません。</p>
      </div>
    </ClientOnly>
  </section>
</template>

<style lang="scss" scoped>
.golfLog {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .block {
    display: flex;
    flex-direction: column;
    gap: 30px;
    p {
      font-size: 16px;
      font-weight: 600;
    }
  }
}
</style>
